module.exports = __webpack_public_path__ + "static/media/am.efeb293a.webp";